import { useTranslation } from 'hooks/useTranslation';
import { isbot } from 'isbot';
import { useEffect, useState } from 'react';
import styles from './BrowserSupportAlert.module.scss';

function isStaticImportSupported() {
  try {
    return 'noModule' in HTMLScriptElement.prototype;
  } catch {
    return false;
  }
}

export const BrowserSupportAlert: React.FC = () => {
  const [isBrowserSupported, setIsBrowserSupported] = useState(true);
  const t = useTranslation();

  useEffect(() => {
    setIsBrowserSupported(
      window.navigator.webdriver ||
        isbot(window.navigator.userAgent) ||
        isStaticImportSupported()
    );
  }, []);

  if (isBrowserSupported) {
    return null;
  }

  return (
    <div className={styles.supportAlert}>
      {t('deprecatedInstructions')} &nbsp;
      <a href={t('deprecatedInstructionUrl')}>{t('deprecatedLinkText')}</a>
    </div>
  );
};
